import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StatusSegments, useNarrowViewport } from '../../components/ListPage';
import ContactsView from './components/ContactsView';
import ClientsView from './components/ClientsView';
import './styles.scss';

type ViewTab = 'contacts' | 'clients';

const VIEW_OPTIONS: { value: ViewTab; label: string }[] = [
  { value: 'contacts', label: 'Contacts' },
  { value: 'clients', label: 'Clients' }
];

/**
 * One register, two views. Each view renders its own ListPage (they have
 * different data hooks, filters and columns); the page owns the Contacts /
 * Clients switch and hands it down as the shell's segments slot.
 */
const Contacts: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentView = (searchParams.get('view') as ViewTab) || 'contacts';
  const isNarrow = useNarrowViewport();

  const handleViewChange = useCallback((tab: ViewTab) => {
    setSearchParams(() => {
      const newParams = new URLSearchParams();
      if (tab !== 'contacts') {
        newParams.set('view', tab);
      }
      return newParams;
    }, { replace: true });
  }, [setSearchParams]);

  const viewToggle = (
    <StatusSegments<ViewTab>
      aria-label="View"
      size={isNarrow ? 'sm' : 'md'}
      value={currentView}
      onChange={handleViewChange}
      segments={VIEW_OPTIONS}
    />
  );

  return currentView === 'contacts' ? (
    <ContactsView viewToggle={viewToggle} />
  ) : (
    <ClientsView viewToggle={viewToggle} />
  );
};

export default Contacts;
